export default __webpack_public_path__ + "assets/img/ict-rectangle.8653541ad5b44371f061a7e6fe629136.svg";